import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { ThemeColor } from "../theme/color";
import "../sidebar/sidebar.css";
import { FontFamily } from "../theme/fontFamily";
import { fontSize } from "../theme/fontSize";
import { fontWeight } from "../theme/fontWeight";
import Users from "../../Icon/Users";
import Star from "../../Icon/Star";
import Delete from "../../Icon/Delete";
import Msg from "../../Icon/Msg";
import NotificationIcon from "../../Icon/Notification";
import Filemanager from "../../Icon/Filemanager";
import Filemanager2 from "../../Icon/Filemanager2";
import Setting from "../../Icon/Setting";
import { hover } from "@testing-library/user-event/dist/hover";
import Logout from "../../Icon/Logout";
import { Collapse, Tooltip } from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";
import Search from "../../Icon/Search";
import Filter from "../../Icon/Filter";
import ProfileDropdown from "../dropdown/Profiledropdown";
import { useLocation, useNavigate } from "react-router-dom";
import SnackbarComponent from "../snackbar/snackbar";
import { ChatBubble, ContactMail, ExpandLess, ExpandMore } from "@mui/icons-material";
import Message from "../../Icon/Message";
import { ProfileFilled } from "@ant-design/icons";
import { useEffect } from "react";
import { setSelectedIndex } from "../../Redux/action/UiAction";
import { useDispatch, useSelector } from "react-redux";
import { GetAllCountTotalUnseenMessages } from "../../Redux/action/NotificationAction";
import { AllCountTotalUnseenMessagesConst } from "../../Redux/constant/NotificationConstant";
import { useState } from "react";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
// import NotificationsIcon from '@mui/icons-material/Notifications';
import Reminder from "../../Icon/Reminder";
import EmailIcon from "../../Icon/EmailIcon";
import ComposeIcon from "../../Icon/ComposeIcon";
import SentIcon from "../../Icon/SentIcon";
import TemplateIcon from "../../Icon/TemplateIcon";
import AccountsIcon from "../../Icon/AccountsIcon";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SummarizeIcon from '@mui/icons-material/Summarize';
import DashboardIcon from "../../Icon/DashboardIcon";
import GlobalSearch from "./globalSearch";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { GetMicrosoftAuthCodeService } from "../../Redux/service/MailService";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import { Badge } from "@mui/material";
import { GetUserChatAction } from "../../Redux/action/SettingAction";
import useChatSocket from "../../socket/useChatSocket";
import { disconnectSocket } from "../../socket/socketClient";

const drawerWidth = 280;

/** Menu key of the Support entry, which is pinned to the bottom of the list. */
const SUPPORT_KEY = "support";
const collapsedDrawerWidth = 80;

// Custom styled tooltip for collapsed sidebar
const StyledTooltip = muiStyled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: '#ffffff',
    color: '#2563eb',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    fontSize: 14,
    fontWeight: 500,
    borderRadius: 10,
    padding: '10px 16px',
    whiteSpace: 'nowrap',
    border: '1px solid rgba(37, 99, 235, 0.1)'
  },
  [`& .MuiTooltip-arrow`]: {
    color: '#ffffff',
    '&::before': {
      border: '1px solid rgba(37, 99, 235, 0.1)'
    }
  }
}));

const SIDEBAR_OPEN_KEY = "sidebar_expanded";

const ACCOUNTS_SUB_ITEMS = [
  {
    label: "Accounts",
    icon: <AccountBalanceWalletIcon />,
    path: "/CAE/payoutlist",
    key: "accounts_payoutlist",
  },
  {
    label: "Summary",
    icon: <SummarizeIcon />,
    path: "/CAE/accounts/summary",
    key: "accounts_summary",
  },
];

const EMAIL_SUB_ITEMS = [
  {
    label: "Compose",
    icon: <ComposeIcon />,
    path: "/CAE/Sendmail",
    key: "send_email",
  },
  { label: "Inbox", icon: <Msg />, path: "/CAE/mailist", key: "mail_list" },
  {
    label: "Sent",
    icon: <SentIcon />,
    path: "/CAE/sentmailist",
    key: "sent_mail_list",
  },
  {
    label: "Email Template",
    icon: <TemplateIcon />,
    path: "/CAE/emailTemplatelist",
    key: "email_templatelist",
  },
];

function ResponsiveDrawer(props) {
  const [role, setrole] = React.useState([]);
  const dispatch = useDispatch();
  const location = useLocation();

  const navigate = useNavigate();
  const itemRefs = React.useRef([]);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [miniopen, setMiniOpen] = React.useState(false);

  const [isClosing, setIsClosing] = React.useState(false);
  const [hoveredIndex, setHoveredIndex] = React.useState(false);
  const [activeItem, setActiveItem] = React.useState(null);
  const [CountTotalUnseenMsg, setCountTotalUnseenMsg] = React.useState();

  // The drawer is re-mounted on every page, so the expanded/collapsed choice is
  // persisted. It must only change when the user toggles it manually.
  const [open, setOpen] = React.useState(
    () => window.localStorage.getItem(SIDEBAR_OPEN_KEY) !== "false"
  );

  const visibleAccountsSubItems = window.sessionStorage.getItem("user_role_type") === "agent"
    ? ACCOUNTS_SUB_ITEMS.filter((item) => item.key !== "accounts_summary")
    : ACCOUNTS_SUB_ITEMS;

  const accountsChildActive = visibleAccountsSubItems.some(
    (item) => item.path === location.pathname
  );
  const emailChildActive = EMAIL_SUB_ITEMS.some(
    (item) => item.path === location.pathname
  );

  const [email, setEmail] = React.useState(emailChildActive);
  const [accountsOpen, setAccountsOpen] = React.useState(accountsChildActive);

  useEffect(() => {
    dispatch(GetAllCountTotalUnseenMessages());
  }, []);
  const CountTotalUnseenMsgState = useSelector(
    (state) =>
      state.notification?.AllCountTotalUnseenMessages?.data?.data
        ?.totalUnseenMessages
  );
  useEffect(() => {
    setCountTotalUnseenMsg(CountTotalUnseenMsgState);
  }, [CountTotalUnseenMsgState]);

  // Live unread badge: the socket pushes a fresh summary on every new / seen
  // message. The REST count is only the seed for the first paint (and the
  // fallback while the socket is down).
  const realtime = useChatSocket();

  useEffect(() => {
    if (realtime.connected) {
      realtime.refreshUnread();
    }
  }, [realtime.connected]);

  const unseenMessageCount = realtime.connected
    ? realtime.unread?.total || 0
    : CountTotalUnseenMsg || 0;

  const handleClick = (item) => {
    setActiveItem(item);
    setOpen(!open);
  };
  const handleClickAccounts = () => {
    if (!open) {
      handleMiniDrawerToggle(true);
    }
    setAccountsOpen(!accountsOpen);
  };

  // Email service can only be used once the Microsoft (Office 365) account is
  // connected, i.e. once the access token has been stored after the OAuth redirect.
  const isMicrosoftConnected = Boolean(
    window.sessionStorage.getItem("ms_auth")
  );

  const handleConnectMicrosoft = async () => {
    try {
      const res = await GetMicrosoftAuthCodeService();
      if (res.status === 200 && res.data?.AuthorizationURL) {
        // same tab, Microsoft redirects back to the app
        window.location.href = res.data.AuthorizationURL;
      } else {
        dispatch(
          showSnackbar("Unable to start Microsoft sign in. Try again.", "error")
        );
      }
    } catch (err) {
      dispatch(
        showSnackbar("Unable to start Microsoft sign in. Try again.", "error")
      );
    }
  };

  const handleClickEmail = () => {
    if (!isMicrosoftConnected) {
      dispatch(
        showSnackbar(
          "Connect your Microsoft account to use the email service.",
          "warning"
        )
      );
      handleConnectMicrosoft();
      return;
    }
    navigate("/CAE/webmail");
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  const handleDrawerClose = () => {
    setIsClosing(true);
    setMobileOpen(false);
  };

  const handleMiniDrawerToggle = (forceOpen) => {
    const next = forceOpen === true ? true : !open;
    window.localStorage.setItem(SIDEBAR_OPEN_KEY, String(next));
    setOpen(next);
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleMobileDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleDrawerToggle = () => {
    setMiniOpen(!miniopen);
  };

  useEffect(() => {
    if (window?.sessionStorage.getItem("user_role_type")) {
      //(window.sessionStorage.getItem("user_role_type"));
      setrole((prev) => [window.sessionStorage.getItem("user_role_type")]);
    }
    console.log(window?.sessionStorage.getItem("user_role_type"));
  }, []);

  const drawerItem = [
    // {
    //   text: "Dashboard",
    //   icon: <Star />,
    //   key: "dashboard",
    // },
    ...(window?.sessionStorage.getItem("user_role_type") === "admin" ||
    window?.sessionStorage.getItem("user_role_type") === "user"
      ? [
          {
            text: "Dashboard",
            icon: <DashboardIcon />,
            // icon: <NotificationsIcon fontSize="large" sx={{ fill: "white" }} />,

            key: "analytics",
            navigate: "/CAE/Dashboard",
          },
        ]
      : []),
    // {
    //   text: "Dashboard",
    //   icon: <DashboardIcon />,
    //   // icon: <NotificationsIcon fontSize="large" sx={{ fill: "white" }} />,

    //   key: "analytics",
    //   navigate: "/CAE/Analytics",
    // },
    {
      text: "Applicants",
      icon: <Users />,
      key: "application",
      navigate: "/CAE/applicationlist",
    },
    {
      text: "Global Search",
      icon: <Search />,
      key: "global_search",
      navigate: "/CAE/globalsearch",
    },
    // {
    //   text: "University",
    //   icon: <Star />,
    //   key: "university",
    // },
    ...(window?.sessionStorage.getItem("user_role_type") === "admin" ||
      window?.sessionStorage.getItem("user_role_type") === "user" ||
      window?.sessionStorage.getItem("user_role_type") === "sub_admin")
      ? [
          {
            text: "File Manager",
            icon: <Filemanager />,
            key: "file_manager",
            navigate: "/CAE/Filemanager",
          },
          {
          text: "Contact",
          icon: <ContactMail />,
          key: "contact",
          navigate: "/CAE/ContactDashboard",
        }
        ]
      : [],
    {
      text: "Settings",
      icon: <Setting />,
      key: "setting",
      navigate: "/CAE/SettingDashboard",
    },
    {
      text: `${
        window.sessionStorage.getItem("user_role_type") === "admin" ||
        window.sessionStorage.getItem("user_role_type") === "user"
          ? "Messages"
          : "Contact CAE"
      }`,
      icon: <Msg />,
      key: "chat",
      navigate: "/CAE/chatlist",
      notify: unseenMessageCount,
    },
    {
      text: "Notification",
      icon: <NotificationIcon />,
      // icon: <NotificationsIcon fontSize="large" sx={{ fill: "white" }} />,

      key: "notification",
      navigate: "/CAE/AllNotification",
    },

    // {
    //   text: "Accounts",
    //   icon: <AccountsIcon />,
    //   key: "accounts",
    //   navigate: "/CAE/payoutlist",
    // },
    ...((window?.sessionStorage.getItem("user_role_type") === "admin" || window?.sessionStorage.getItem("user_role_type") === "agent")
      ? [
          {
            text: "Accounts",
            icon: <AccountsIcon />,
            key: "accountss",
            navigate: "/CAE/payoutlist",
          },
        ]
      : []),

    // ...(!(
    //   window.sessionStorage.getItem("user_role_type") === "admin"
    //   // window.sessionStorage.getItem("role") === "agent_counsellor"
    // )
    //   ? [
    //     {
    //       text: "Accounts",
    //       icon: <Msg />,
    //       key: "accounts",
    //       navigate: "/CAE/payoutlist",
    //     },
    //     ]
    //   : []),

    // {
    //   text: "Agent",
    //   icon: <Msg />,
    //   key: "gent",
    // },

    // Kept last on purpose: Support is rendered at the very bottom of the menu,
    // below Email. See renderDrawer.
    {
      text: "Support",
      icon: <ChatBubble sx={{ fill: "#fff" }} />,
      key: "support",
      navigate: "/CAE/support",
    },
  ];

  const filteredArray = drawerItem.filter(
    (item) => !(item.key === "accounts" && role.includes("admin"))
  );

  // Support sits below every other entry, including Email. It stays inside
  // filteredArray so the index-based selection and refs keep working; it is
  // simply skipped by the list loop and rendered after the Email block.
  const supportIndex = filteredArray.findIndex(
    (item) => item.key === SUPPORT_KEY
  );
  const supportItem = supportIndex === -1 ? null : filteredArray[supportIndex];

  const selectedIndex = useSelector((state) => state.ui.selectedIndex);

  const handleItemClick = (index, navigateTo) => {
    dispatch(setSelectedIndex(index));
    if (navigateTo === "/CAE/chatlist") {
      dispatch(GetUserChatAction());
    }
    if (navigateTo) {
      navigate(navigateTo);
    }
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  useEffect(() => {
    // Ensure itemRefs length matches filteredArray length
    itemRefs.current = Array(filteredArray.length).fill(null);
  }, [filteredArray.length]);

  const handleSubItemClick = (item) => {
    dispatch(setSelectedIndex(item.key));
    navigate(item.path);
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  const renderSubList = (items, expanded) => (
    <List
      component="div"
      disablePadding
      sx={
        expanded
          ? {
              ml: "34px",
              pl: "10px",
              mb: 0.5,
              borderLeft: "1px solid rgba(255, 255, 255, 0.2)",
            }
          : {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 0.5,
            }
      }
    >
      {items.map((item) => {
        const active = location.pathname === item.path;
        const button = (
          <ListItemButton
            onClick={() => handleSubItemClick(item)}
            sx={{
              borderRadius: "10px",
              minHeight: 38,
              mb: 0.25,
              py: 0.75,
              px: expanded ? 1.25 : 1,
              width: expanded ? "auto" : 44,
              justifyContent: expanded ? "flex-start" : "center",
              color: active ? "#ffffff" : "rgba(255, 255, 255, 0.72)",
              backgroundColor: active ? "rgba(255, 255, 255, 0.18)" : "transparent",
              transition: "background-color 0.2s ease, color 0.2s ease",
              "& .MuiListItemIcon-root svg": {
                width: 18,
                height: 18,
                fontSize: 18,
                fill: "currentColor",
              },
              "&:hover": {
                backgroundColor: active
                  ? "rgba(255, 255, 255, 0.24)"
                  : "rgba(255, 255, 255, 0.08)",
                color: "#ffffff",
              },
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: expanded ? 1.25 : 0,
                display: "flex",
                justifyContent: "center",
                color: "inherit",
              }}
            >
              {item.icon}
            </ListItemIcon>
            {expanded && (
              <ListItemText
                sx={{ m: 0 }}
                primary={
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: active ? 600 : 500,
                      letterSpacing: "0.2px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.label}
                  </Typography>
                }
              />
            )}
          </ListItemButton>
        );

        return expanded ? (
          <React.Fragment key={item.key}>{button}</React.Fragment>
        ) : (
          <StyledTooltip
            key={item.key}
            title={item.label}
            placement="right"
            arrow
          >
            {button}
          </StyledTooltip>
        );
      })}
    </List>
  );

  /**
   * One sidebar entry. Extracted from the list `.map()` so the same markup can
   * also render Support at the very bottom, after the Email block, without
   * duplicating ~190 lines of JSX. `expanded` is passed in because it belongs to
   * renderDrawer, exactly like renderSubList above.
   */
  const renderNavItem = (data, index, expanded) => {
    if (data.key === "accounts" && role.includes("admin")) return "";

    if (data.key === "accountss") {
      return (
        <React.Fragment key={data.key}>
          <ListItem
            ref={(el) => (itemRefs.current[index] = el)}
            disablePadding
            onMouseEnter={() =>
              data.key === "file_manager" ? setHoveredIndex(true) : ""
            }
            onMouseLeave={() =>
              data.key === "file_manager" ? setHoveredIndex(false) : ""
            }
            onClick={handleClickAccounts}
            className="list-item"
          >
            <StyledTooltip title={!expanded ? data.text : ""} placement="right" arrow>
              <ListItemButton
                className="sidebar-item-button"
                sx={{
                  justifyContent: expanded ? 'flex-start' : 'center',
                  borderRadius: '12px',
                  mb: 0.5,
                  py: 1.25,
                  px: expanded ? 2 : 1.5,
                  backgroundColor: accountsChildActive
                    ? 'rgba(255, 255, 255, 0.12)'
                    : 'transparent',
                  transition: 'background-color 0.2s ease',
                  position: 'relative',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.16)',
                  }
                }}
              >
                <ListItemIcon sx={{ 
                  minWidth: 0, 
                  mr: expanded ? 2 : 0, 
                  display: 'flex', 
                  justifyContent: 'center',
                  color: 'inherit'
                }}>
                  {data.icon}
                </ListItemIcon>

                {expanded && (
                  <ListItemText 
                    primary={
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <Typography
                          sx={{
                            fontSize: '14px',
                            fontWeight: 500,
                            letterSpacing: '0.2px'
                          }}
                        >
                          {data?.text}
                        </Typography>
                        {accountsOpen ? (
                          <ExpandLess sx={{ fontSize: 20 }} />
                        ) : (
                          <ExpandMore sx={{ fontSize: 20 }} />
                        )}
                      </Box>
                    }
                    sx={{ margin: 0 }}
                  />
                )}
              </ListItemButton>
            </StyledTooltip>
          </ListItem>

          <Collapse in={accountsOpen} timeout={250} unmountOnExit>
            {renderSubList(visibleAccountsSubItems, expanded)}
          </Collapse>
        </React.Fragment>
      );
    }

    return (
      <ListItem
        key={data.key}
        ref={(el) => (itemRefs.current[index] = el)}
        disablePadding
        onMouseEnter={() =>
          data.key === "file_manager" ? setHoveredIndex(true) : ""
        }
        onMouseLeave={() =>
          data.key === "file_manager" ? setHoveredIndex(false) : ""
        }
        onClick={() => handleItemClick(index, data.navigate)}
        className={
          location.pathname === data.navigate
            ? "list-item-active"
            : "list-item"
        }
      >
        <StyledTooltip title={!expanded ? data.text : ""} placement="right" arrow>
          <ListItemButton
            className="sidebar-item-button"
            sx={{
              justifyContent: expanded ? 'flex-start' : 'center',
              borderRadius: '12px',
              mb: 0.5,
              py: 1.25,
              px: expanded ? 2 : 1.5,
              transition: 'background-color 0.2s ease',
              position: 'relative',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.16)',
              }
            }}
          >
            <ListItemIcon sx={{ 
              minWidth: 0, 
              mr: expanded ? 2 : 0, 
              display: 'flex', 
              justifyContent: 'center',
              color: 'inherit'
            }}>
              {data.key === "chat" ? (
                <Badge
                  badgeContent={unseenMessageCount}
                  color="error"
                  max={99}
                  overlap="circular"
                  invisible={!unseenMessageCount}
                  sx={{
                    "& .MuiBadge-badge": {
                      fontSize: 10,
                      height: 16,
                      minWidth: 16,
                    },
                  }}
                >
                  {data.icon}
                </Badge>
              ) : data.key === "file_manager" ? (
                hoveredIndex ? (
                  <Filemanager2 />
                ) : (
                  data.icon
                )
              ) : (
                data.icon
              )}
            </ListItemIcon>

            {expanded && (
              <ListItemText 
                primary={
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        fontWeight: 500,
                        letterSpacing: '0.2px'
                      }}
                    >
                      {data?.text}
                    </Typography>
                    {data.key === "chat" && unseenMessageCount > 0 && (
                      <Box
                        sx={{
                          backgroundColor: location.pathname === data.navigate ? '#ef4444' : '#ffffff',
                          color: location.pathname === data.navigate ? '#ffffff' : '#2563eb',
                          borderRadius: '12px',
                          px: 1,
                          py: 0.25,
                          fontSize: '11px',
                          fontWeight: 600,
                          minWidth: '20px',
                          textAlign: 'center'
                        }}
                      >
                        {unseenMessageCount > 99
                          ? "99+"
                          : unseenMessageCount}
                      </Box>
                    )}
                  </Box>
                }
                sx={{ margin: 0 }}
              />
            )}
          </ListItemButton>
        </StyledTooltip>
      </ListItem>
    );
  };

  const renderDrawer = (expanded, isMobile = false) => (
    <div className="sidebar-list w-100 h-100">
      <div className={`sidebar-header ${expanded ? "" : "collapsed"}`}>
        <div className="sidebar-logo-container">
          <img src="/assest/Group.png" alt="logo" className="sidebar-logo" />
          {expanded && (
            <div className="sidebar-brand">
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '18px',
                  letterSpacing: '-0.5px'
                }}
                color="#ffffff"
              >
                CRM
              </Typography>
            </div>
          )}
        </div>
        <IconButton
          onClick={isMobile ? handleDrawerClose : handleMiniDrawerToggle}
          aria-label={isMobile ? "close menu" : "toggle sidebar"}
          className="sidebar-toggle"
          size="small"
        >
          {isMobile || expanded ? (
            <ChevronLeft sx={{ fontSize: 20 }} />
          ) : (
            <ChevronRight sx={{ fontSize: 20 }} />
          )}
        </IconButton>
      </div>
      <div className="sidebar-list-content">
        <List sx={{ padding: '8px 12px' }}>
          {/* Support is rendered separately at the bottom of the list. */}
          {filteredArray?.map((data, index) =>
            data.key === SUPPORT_KEY ? null : renderNavItem(data, index, expanded)
          )}
          {window.sessionStorage.getItem("user_role_type") !== "agent" && (
            <ListItem key={"Mail"} disablePadding className="list-item">
              <StyledTooltip
                title={
                  !isMicrosoftConnected
                    ? "Connect your Microsoft account to use Email"
                    : !expanded
                    ? "Email"
                    : ""
                }
                placement="right"
                arrow
              >
                <ListItemButton
                  onClick={handleClickEmail}
                  className="sidebar-item-button"
                  sx={{
                    justifyContent: expanded ? 'flex-start' : 'center',
                    borderRadius: '12px',
                    mb: 0.5,
                    py: 1.25,
                    px: expanded ? 2 : 1.5,
                    backgroundColor: emailChildActive
                      ? 'rgba(255, 255, 255, 0.12)'
                      : 'transparent',
                    transition: 'background-color 0.2s ease',
                    position: 'relative',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.16)',
                    }
                  }}
                >
                  <ListItemIcon sx={{
                    minWidth: 0,
                    mr: expanded ? 2 : 0,
                    display: 'flex',
                    justifyContent: 'center',
                    color: 'inherit',
                    opacity: isMicrosoftConnected ? 1 : 0.55
                  }}>
                    <EmailIcon />
                  </ListItemIcon>
                  {expanded && (
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', gap: 1 }}>
                          <Typography
                            sx={{
                              fontSize: '14px',
                              fontWeight: 500,
                              letterSpacing: '0.2px',
                              opacity: isMicrosoftConnected ? 1 : 0.7
                            }}
                          >
                            Email
                          </Typography>
                          {!isMicrosoftConnected && (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                px: 0.75,
                                py: 0.25,
                                borderRadius: '8px',
                                backgroundColor: 'rgba(255, 255, 255, 0.16)',
                                fontSize: '10px',
                                fontWeight: 600,
                                whiteSpace: 'nowrap'
                              }}
                            >
                              <LinkOffIcon sx={{ fontSize: 13 }} />
                              Connect
                            </Box>
                          )}
                        </Box>
                      }
                      sx={{ margin: 0 }}
                    />
                  )}
                </ListItemButton>
              </StyledTooltip>
              </ListItem>
          )}

          {/* Bottom of the menu, below Email. */}
          {supportItem && renderNavItem(supportItem, supportIndex, expanded)}
        </List>
      </div>

      <div className="sidebar-footer">
        <ListItemButton
          onClick={() => {
            // Closes the websocket and wipes this user's cached API data.
            disconnectSocket();
            sessionStorage.removeItem("user_token");
            sessionStorage.removeItem("ms_auth");
            sessionStorage.removeItem("ms_auth_skipped");
            navigate("/");
            navigate(0);
          }}
          sx={{
            borderRadius: '12px',
            py: 1.5,
            px: expanded ? 2 : 1.5,
            justifyContent: expanded ? 'flex-start' : 'center',
            transition: 'background-color 0.2s ease',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.12)',
            }
          }}
        >
          <ListItemIcon sx={{ 
            minWidth: 0, 
            mr: expanded ? 2 : 0,
            display: 'flex',
            justifyContent: 'center',
            color: 'rgba(255, 255, 255, 0.9)'
          }}>
            <Logout />
          </ListItemIcon>
          {expanded && (
            <ListItemText 
              primary={
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: 'rgba(255, 255, 255, 0.9)',
                    letterSpacing: '0.2px'
                  }}
                >
                  Log out
                </Typography>
              }
            />
          )}
        </ListItemButton>
      </div>
    </div>
  );

  // Remove this const when copying and pasting into your project.
  const container =
    window !== undefined ? () => window.document.body : undefined;
  const calculatedDrawerWidth = open ? drawerWidth : collapsedDrawerWidth;
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${calculatedDrawerWidth}px)` },
          ml: { sm: `${calculatedDrawerWidth}px` },
          //   height:200,
          background: "#F6FAFF",
          boxShadow: "none",
          color: "black",
          transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1), margin 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <Toolbar
          sx={{
            minHeight: { xs: 64, sm: 72 },
            px: { xs: 1.5, sm: 2, md: 3 },
            gap: { xs: 1, sm: 1.5 },
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleMobileDrawerToggle}
            sx={{
              mr: 0.5,
              display: { sm: "none" },
              color: ThemeColor.NAVYBLUE,
              flexShrink: 0,
            }}
          >
            <MenuIcon />
          </IconButton>
          <Box className="toolbar-content">
            <Box className="toolbar-search">{props.globalsearch}</Box>
            <Box className="toolbar-profile">
              <ProfileDropdown />
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        // sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        {/* <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: ThemeColor.BLUE,
              height: "100vh",
              overflow: "hidden",
              border: "none",
            },
            "& .MuiListItem-root": {
              // padding: '12px 16px',
              borderRadius: "8px",
              border: "none",
              transition: "background-color 0.3s ease-in-out",
              color: ThemeColor.WHITE,
              borderRadius: "25px 0px 0px 25px",
              overflow: "hidden",
              mr: 15,

              "&:hover": {
                backgroundColor: ThemeColor.WhHITESMOKE, // Add your hover background color
                cursor: "pointer", // Change cursor to pointer on hover
                mr: 15,
                color: ThemeColor.BLUE,
                borderRadius: "25px 0px 0px 25px",
                "& svg": {
                  fill: ThemeColor.BLUE, // Change to desired hover color
                },
              },
            },
          }}
          className="sidebar"
        >
          {drawer}
        </Drawer> */}
        {/* <Drawer
          variant="permanent"
          open={miniopen}
          sx={{
            display: { xs: "none", sm: "block" },
          // width: open ? drawerWidth : collapsedDrawerWidth
            width: miniopen ? drawerWidth : collapsedDrawerWidth,
            flexShrink: 0,
            whiteSpace: "nowrap",
            boxSizing: "border-box",
            "& .MuiDrawer-paper": {
              width: open ? drawerWidth : collapsedDrawerWidth,
              backgroundColor: ThemeColor.BLUE,
              overflowX: "hidden",
              transition: "width 0.3s ease-in-out",
              boxSizing: "border-box",
              border: "none",
            },
            "& .MuiListItem-root": {
              color: ThemeColor.WHITE,
              borderRadius: "25px 0px 0px 25px",
              transition: "background-color 0.3s ease-in-out",
              "&:hover": {
                backgroundColor: ThemeColor.WhHITESMOKE,
                color: ThemeColor.BLUE,
                "& svg": {
                  fill: ThemeColor.BLUE,
                },
              },
            },
          }}
        >
          <IconButton
            onClick={handleDrawerToggle}
            sx={{ color: ThemeColor.WHITE, mt: 1, mb: 2, mx: "auto" }}
          >
            {open ? <ChevronLeft /> : <ChevronRight />}
          </IconButton>
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              backgroundColor: ThemeColor.BLUE,
              border: "none",
              height: "100vh",
              overflow: "hidden",

              // pl: 2,
            },
            "& .MuiListItem-root": {
              // padding: '12px 16px',
              borderRadius: "8px",
              transition: "background-color 0.3s ease-in-out",
              color: ThemeColor.WHITE,
              borderRadius: "25px 0px 0px 25px",
              mr: 15,
              overflow: "none",

              "&:hover": {
                backgroundColor: ThemeColor.WhHITESMOKE, // Add your hover background color
                cursor: "pointer", // Change cursor to pointer on hover
                mr: 15,
                color: ThemeColor.BLUE,
                borderRadius: "25px 0px 0px 25px",
                "& svg": {
                  fill: ThemeColor.BLUE, // Change to desired hover color
                },
              },
            },
          }}
          open
        >
          {drawer}
        </Drawer> */}

        <Drawer
          variant="permanent"
          open={open}
          sx={{
            display: { xs: "none", sm: "block" },
            width: open ? drawerWidth : collapsedDrawerWidth,
            flexShrink: 0,
            whiteSpace: "nowrap",
            boxSizing: "border-box",
            "& .MuiDrawer-paper": {
              width: open ? drawerWidth : collapsedDrawerWidth,
              background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 50%, #2563eb 100%)",
              overflowX: "hidden",
              transition: "width 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxSizing: "border-box",
              border: "none",
              boxShadow: "4px 0 24px rgba(0, 0, 0, 0.12)",
            },
            "& .MuiListItem-root": {
              color: "rgba(255, 255, 255, 0.9)",
              borderRadius: "12px",
              transition: "all 0.2s ease-in-out",
            },
          }}
        >
          {renderDrawer(open)}
        </Drawer>

        {/* ✅ Temporary Drawer for Mobile */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerClose}
          onTransitionEnd={handleDrawerTransitionEnd}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 50%, #2563eb 100%)",
              height: "100vh",
              overflow: "hidden",
              border: "none",
              boxShadow: "4px 0 24px rgba(0, 0, 0, 0.12)",
            },
            "& .MuiListItem-root": {
              borderRadius: "12px",
              color: "rgba(255, 255, 255, 0.9)",
              transition: "all 0.2s ease-in-out",
            },
          }}
          className="sidebar mobilescroll"
        >
          {renderDrawer(true, true)}
        </Drawer>
      </Box>
      {/* main content box */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1.5, sm: 2, md: 3 },
          height: "100vh",
          overflowX: "hidden",
          width: { xs: "100%", sm: `calc(100% - ${calculatedDrawerWidth}px)` },
          maxWidth: "100%",
          minWidth: 0,
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 64, sm: 72 } }} />
        {props.maincontent}
        <div className="w-100">
          <SnackbarComponent />
        </div>
      </Box>
    </Box>
  );
}

export default ResponsiveDrawer;
